"use client";

import { useRef } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/catalyst/button";

export function TextButton({ children }) {
  const router = useRouter();
  const hasClicked = useRef(false);

  const handleClick = () => {
    if (!hasClicked.current) {
      hasClicked.current = true;
      router.back();
    }
  };

  return (
    <Button
      onClick={handleClick}
      aria-label={typeof children === "string" ? children : "Back"}
      plain
    >
      {children}
    </Button>
  );
}
